import { Layout } from "@layouts";
import InsuranceSamplesImage from "../../../assets/insurance_samples.jpg";
import { useTranslation } from "react-i18next";

const HERO_SECTION_HEIGHT = 288;

export const GroupInsurancePageTemplate = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Layout
      variant="dashboard"
      header={t("groupInsurance.header")}
      subheader={
        <div className="flex flex-row items-start justify-between max-w-5xl">
          <div className="text-neutral-dark text-base font-normal mt-2">
            {t("groupInsurance.subheader")}
          </div>
        </div>
      }
    >
      <div className="rounded-md max-w-5xl">
        <div className="flex flex-col gap-6">
          <div
            className="flex flex-col md:flex-row mt-4 items-center md:items-start gap-6 max-w-5xl border border-neutral-light rounded-2xl p-6 bg-white"
            style={{ minHeight: HERO_SECTION_HEIGHT }}
          >
            <img
              src={InsuranceSamplesImage}
              alt={t("groupInsurance.hero.alt")}
              className="w-40 md:w-60 lg:w-70 lg:min-w-70 lg:max-w-70 h-auto rounded-xl border border-neutral-medium"
            />
            <div className="flex flex-col text-left space-y-3">
              <p className="text-sm font-semibold text-neutral-mediumDark uppercase tracking-wide">
                {t("groupInsurance.hero.kicker")}
              </p>
              <h3 className="text-neutral-darkest text-2xl font-semibold">
                {t("groupInsurance.hero.title")}
              </h3>
              <p className="text-neutral-dark text-base font-normal">
                {t("groupInsurance.hero.description")}
              </p>
              <p className="text-neutral-dark text-base font-normal">
                {t("groupInsurance.hero.notAvailable")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
